import React, { useContext as useContextCore } from 'react'
import { useLocalStorage } from 'react-use'

const CHAT_BUBBLE_VISIBLE_STORAGE_KEY = 'ai-chat-bubble:visible'

export type ChatBubbleVisibilityContextType = {
  isChatBubbleVisible: boolean
  toggleChatBubbleVisible: () => void
}

const context = React.createContext<ChatBubbleVisibilityContextType>({} as ChatBubbleVisibilityContextType)

export type ChatBubbleVisibilityProviderProps = { children: React.ReactNode }

export const ChatBubbleVisibilityProvider = ({ children }: ChatBubbleVisibilityProviderProps) => {
  const [storedVisible, setStoredVisible] = useLocalStorage<boolean>(CHAT_BUBBLE_VISIBLE_STORAGE_KEY, true)
  const isChatBubbleVisible = storedVisible ?? true
  // Direct value, not a functional updater: react-use's useLocalStorage setter runs updaters
  // against mount-time stale state, so a toggle sticks after one flip. The provider re-renders
  // per change and the sole caller fires once per click, so the read value is fresh.
  const toggleChatBubbleVisible = () => setStoredVisible(!isChatBubbleVisible)

  return <context.Provider value={{ isChatBubbleVisible, toggleChatBubbleVisible }}>{children}</context.Provider>
}

export const useChatBubbleVisibilityContext = () => useContextCore(context)
